import { DashboardLayout } from '@/components/layouts/DashboardLayout'
import { ProjectCreateWizard } from '@/components/features/project-create-wizard/ProjectCreateWizard'

export default function ProjectsNewPage() {
  return (
    <DashboardLayout>
      <ProjectCreateWizard />
    </DashboardLayout>
  )
}
